module.exports = __webpack_public_path__ + "img/74.cbd5e27f.png";